module.exports = __webpack_public_path__ + "static/media/jkboselogo.265526a8.png";